import { Container, Flex } from 'src/components/ui';
import AuthForm from 'src/components/auth/AuthForm';

const SignUp = () => (
	<Container maxW="lg">
		<Flex direction="column" gap={12}>
			<Flex
				gap={12}
				direction={{ base: 'column', md: 'row' }}
				alignItems="center"
			>
				<AuthForm />
			</Flex>
		</Flex>
	</Container>
);

export default SignUp;
